/* eslint-disable react-hooks/exhaustive-deps */
import {
  Loader2,
  Trash2,
  ChevronDown,
  ChevronRight,
  X,
  AlertCircle,
  Maximize2
} from 'lucide-react'
import moment from 'moment'
import { useCallback, useEffect, useState, Fragment } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Table,
  Modal
} from 'react-bootstrap'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Select from 'react-select'
import InputDatePicker from '../../../components/Input/DatePicker/InputDatePicker'
import api from '../../../config/AxiosInstance'
import { formatThousandSeparator } from '../../../utils/TextFormatter'
import toast, { Toaster } from 'react-hot-toast'

const CreateOutboundPlan = () => {
  const [warehouses, setWarehouses] = useState([])
  const [warehouseExternals, setWarehouseExternals] = useState([])
  const { state } = useLocation()
  const navigate = useNavigate()

  const headerTitleStyle = {
    color: 'var(--primary-orange)',
    fontSize: '24px',
    fontWeight: '600'
  }

  const cardStyle = {
    border: 'none',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
    borderRadius: '16px',
    padding: '1.75rem',
    marginBottom: '1.5rem',
    backgroundColor: '#fff'
  }

  const tableHeaderStyle = {
    fontSize: '13px',
    fontWeight: '600',
    color: '#4F4F4F',
    letterSpacing: '0.5px',
    backgroundColor: '#f8f9fa',
    borderBottom: '2px solid #e0e0e0',
    padding: '12px 8px'
  }

  const labelDetailStyle = {
    fontSize: '0.75rem',
    fontWeight: '700',
    color: '#828282',
    textTransform: 'uppercase',
    marginBottom: '0.35rem',
    letterSpacing: '0.5px'
  }

  const [dataSj, setDataSj] = useState([])
  const [selectSj, setSelectSj] = useState(state?.selectedSj ?? [])
  const [loadingListSj, setLoadingListSj] = useState(false)
  const [buttonSearch, setButtonSearch] = useState(false)

  // Frontend dynamic filter states
  const [selectedAddressType, setSelectedAddressType] = useState('All')
  const [selectedRayon, setSelectedRayon] = useState('All')
  const [selectedZoning, setSelectedZoning] = useState('All')

  // Expanded detail rows tracker
  const [expandedRows, setExpandedRows] = useState({})

  // Modal Review tracker
  const [showModalSuggest, setShowModalSuggest] = useState(false)
  const [loadingSuggest, setLoadingSuggest] = useState(false)
  const [suggestedSjs, setSuggestedSjs] = useState([])
  const [expandedSuggestRows, setExpandedSuggestRows] = useState({})

  // Batch Selection Modal Tracker
  const [showModalBatch, setShowModalBatch] = useState(false)
  const [loadingBatches, setLoadingBatches] = useState(false)
  const [availableBatches, setAvailableBatches] = useState([])
  const [activeSelectBatchInfo, setActiveSelectBatchInfo] = useState(null)

  const [searchDataSj, setSearchDataSj] = useState(
    state?.filterData ?? {
      src: '',
      other_src: [],
      delivery_date_start: moment().format('YYYY-MM-DD'),
      delivery_date_end: moment().format('YYYY-MM-DD')
    }
  )

  useEffect(() => {
    getWarehouses()
    getWarehouseExternals()
  }, [])

  useEffect(() => {
    if (state) {
      getSjDraftLists()
    }
  }, [state])

  const toggleRow = (code) => {
    setExpandedRows((prev) => ({
      ...prev,
      [code]: prev[code] === undefined ? false : !prev[code]
    }))
  }

  // Reconstruct pickup_command from returned items array
  const mapItemsToPickupCommand = (items) => {
    return (items || []).map((item) => ({
      id: item.item_id || Math.random().toString(),
      item_id: item.item_id,
      batch_id: item.batch_id,
      item_code: item.item_code,
      item_name: item.item_name,
      item_alias: item.item_alias,
      batch: item.batch,
      exp_date: item.batch_exp,
      qty: Number(item.pick_up_qty || 0),
      uom: item.pick_up_qty_uom || item.pick_up_uom,
      total_pack: Number(item.pick_up_pack || 0),
      uom_pack: item.pick_up_pack_uom || item.pick_up_uom,
      qty_pack: Number(item.pick_up_pack || 0),
      volume_item: Number(item.volume_item || 0)
    }))
  }

  const isItemShortage = (item) => {
    const availableQty = Number(item.available_qty || 0)
    if (availableQty === 0) return true

    const availUom = (item.available_qty_uom || '').trim().toLowerCase()
    const qtyUom = (
      item.pick_up_qty_uom ||
      (item.pick_up_pack_uom ? item.pick_up_uom : '') ||
      ''
    )
      .trim()
      .toLowerCase()
    const packUom = (
      item.pick_up_pack_uom ||
      (item.pick_up_qty_uom ? item.pick_up_uom : '') ||
      ''
    )
      .trim()
      .toLowerCase()

    if (availUom && availUom === qtyUom) {
      return Number(item.pick_up_qty || 0) > availableQty
    }
    if (availUom && availUom === packUom) {
      return Number(item.pick_up_pack || 0) > availableQty
    }

    return Number(item.pick_up_pack || item.pick_up_qty || 0) > availableQty
  }

  const isSjShortage = (sj) => {
    if (sj.is_rr) return false
    return (sj.items || []).some(isItemShortage)
  }

  const handleSelectSj = (sjCode, checked) => {
    setDataSj((prevData) =>
      prevData.map((sj) =>
        sj.code === sjCode ? { ...sj, selected: checked } : sj
      )
    )
    if (checked) {
      const selectedItem = dataSj.find((sj) => sj.code === sjCode)
      if (selectedItem) {
        setSelectSj((prevSelect) => [...prevSelect, selectedItem])
      }
    } else {
      setSelectSj((prevSelect) => prevSelect.filter((sj) => sj.code !== sjCode))
    }
  }

  const fetchSuggestDetails = async (overriddenSelectSj = null) => {
    const activeSelectSj =
      overriddenSelectSj !== null ? overriddenSelectSj : selectSj
    if (activeSelectSj.length === 0) return

    try {
      setLoadingSuggest(true)
      setShowModalSuggest(true)

      const payload = {
        source_warehouse: searchDataSj.src,
        pickup: activeSelectSj
          .filter((sj) => sj.is_sj_draft)
          .map((sj) => ({
            code: sj.code,
            items: (sj.items || []).map((item) => ({
              batch_id: item.batch_id,
              batch: item.batch,
              total_pack: Number(item.pick_up_pack || 0),
              item_alias: item.item_alias
            }))
          })),
        transfer: activeSelectSj
          .filter((sj) => sj.is_tr)
          .map((sj) => sj.id || sj.code),
        return: activeSelectSj.filter((sj) => sj.is_rr).map((sj) => sj.code)
      }

      const res = await api.post('/outbound/sjdraft/suggest', payload)
      if (res.status === 200) {
        const rawSuggested = res.data.data.select_pick_up || []
        const mapped = rawSuggested.map((sj) => ({
          ...sj,
          draft: sj.code,
          sj: sj.code,
          pickup_command: mapItemsToPickupCommand(sj.items),
          selected: true
        }))
        setSuggestedSjs(mapped)
      }
    } catch (err) {
      const errMsg =
        err?.response?.data?.errors?.message ||
        'An error occurred fetching suggestion'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoadingSuggest(false)
    }
  }

  const handleOpenBatchSelector = async (sjCode, item) => {
    setActiveSelectBatchInfo({ sjCode, item })
    setShowModalBatch(true)
    setLoadingBatches(true)
    setAvailableBatches([])
    try {
      const res = await api.post('/outbound/sjdraft/show-batch', {
        src: searchDataSj.src,
        item_code: item.item_code
      })
      if (res.status === 200) {
        setAvailableBatches(res.data.data || [])
      }
    } catch (err) {
      const errMsg =
        err?.response?.data?.errors?.message ||
        'An error occurred fetching batches'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoadingBatches(false)
    }
  }

  const handleSelectNewBatch = (selectedBatch) => {
    if (!activeSelectBatchInfo) return
    const { sjCode, item } = activeSelectBatchInfo

    const updatedSelectSj = selectSj.map((sj) => {
      if (sj.code === sjCode) {
        return {
          ...sj,
          items: (sj.items || []).map((i) => {
            if (
              i.item_code === item.item_code &&
              i.item_alias === item.item_alias
            ) {
              return {
                ...i,
                batch_id: selectedBatch.batch_id,
                batch: selectedBatch.batch,
                batch_exp: selectedBatch.expired_date
                  ? moment(
                      selectedBatch.expired_date,
                      'DD-MM-YYYY'
                    ).toISOString()
                  : i.batch_exp
              }
            }
            return i
          })
        }
      }
      return sj
    })

    setSelectSj(updatedSelectSj)
    setShowModalBatch(false)

    // Trigger re-fetch suggestions with updated batch
    fetchSuggestDetails(updatedSelectSj)
  }

  const handleDeleteSuggestSj = (sjCode) => {
    setDataSj((prevData) =>
      prevData.map((sj) =>
        sj.code === sjCode ? { ...sj, selected: false } : sj
      )
    )

    const updatedSelectSj = selectSj.filter((sj) => sj.code !== sjCode)
    setSelectSj(updatedSelectSj)

    const updatedSuggest = suggestedSjs.filter((sj) => sj.code !== sjCode)
    setSuggestedSjs(updatedSuggest)

    if (updatedSuggest.length === 0) {
      setShowModalSuggest(false)
    } else {
      fetchSuggestDetails(updatedSelectSj)
    }
  }

  const toggleSuggestRow = (code) => {
    setExpandedSuggestRows((prev) => ({
      ...prev,
      [code]: prev[code] === undefined ? false : !prev[code]
    }))
  }

  const getWarehouses = async () => {
    try {
      const res = await api.get(
        '/master/warehouses/all?is_parent=true&forUser=1'
      )
      if (res.status === 200) {
        const options = res.data.data.reduce((acc, data) => {
          acc.push({
            value: data.warehouse_id,
            label: data.warehouse_name,
            id: data.id
          })
          return acc
        }, [])
        setWarehouses(options)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  const getWarehouseExternals = async () => {
    try {
      const res = await api.get(
        '/master/warehouses/all?type=external,consignment'
      )
      if (res.status === 200) {
        const options = res.data.data.reduce((acc, data) => {
          acc.push({ value: data.warehouse_id, label: data.warehouse_name })
          return acc
        }, [])
        setWarehouseExternals(options)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  const getSjDraftLists = async () => {
    try {
      setLoadingListSj(true)
      const payload = {
        src: searchDataSj.src,
        other_src: searchDataSj.other_src.map((item) => item.value),
        start_date: searchDataSj.delivery_date_start,
        end_date: searchDataSj.delivery_date_end,
        srcLabel: warehouses?.find((item) => item.value === searchDataSj.src)
          ?.label
      }
      const res = await api.post('/outbound/sjdraft/search', payload)
      if (res.status === 200) {
        const rawPickUps = res.data.data.pick_ups || []
        const values = rawPickUps.reduce((acc, sj) => {
          const filterSjSelected = selectSj.some(
            (sjValue) => sjValue.code === sj.code
          )
          acc.push({
            ...sj,
            // Fallback for draft property if draftCode or sj not present
            draft: sj.code,
            sj: sj.code,
            pickup_command: mapItemsToPickupCommand(sj.items),
            selected: filterSjSelected
          })
          return acc
        }, [])
        setDataSj(values)
        setButtonSearch(true)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoadingListSj(false)
    }
  }

  const handleSearchDataSj = (name, value) => {
    setButtonSearch(false)
    if (state) {
      navigate('', { state: null })
    }
    if (name === 'other_src') {
      const tmpValueMultiWarehouseExternal = value.map((item) => item.value)
      setSearchDataSj((prevSearchDataDj) => ({
        ...prevSearchDataDj,
        other_src:
          warehouseExternals.filter((item) =>
            tmpValueMultiWarehouseExternal.includes(item.value)
          ) || []
      }))
    } else {
      setSearchDataSj((prevSearchDataDj) => ({
        ...prevSearchDataDj,
        [name]: value
      }))
    }
  }

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 45,
      minHeight: 45,
      borderRadius: '8px',
      borderColor: '#e9ecef',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#f89d1d'
      }
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '43px',
      padding: '0 8px',
      display: 'flex',
      alignItems: 'center'
    }),
    input: (provided) => ({
      ...provided,
      margin: '0px'
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '43px'
    })
  }

  const customMultiStyles = {
    control: (base) => ({
      ...base,
      height: 45,
      minHeight: 45,
      borderRadius: '8px',
      borderColor: '#e9ecef',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#f89d1d'
      }
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '43px',
      padding: '0 8px',
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'nowrap',
      overflowX: 'auto',
      maxWidth: '100%',
      scrollbarWidth: 'thin',
      scrollbarColor: '#ccc transparent'
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      order: -1,
      marginRight: '8px'
    }),
    multiValue: (provided) => ({
      ...provided,
      marginTop: '0px',
      whiteSpace: 'nowrap',
      maxWidth: 'none',
      minWidth: 'none',
      width: 'fit-content',
      backgroundColor: 'white',
      boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.10)',
      borderRadius: '4px',
      border: '1px solid #E0E0E0',
      marginBottom: '0px'
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      marginLeft: '-1rem',
      display: 'inline-flex',
      gap: 2,
      whiteSpace: 'nowrap',
      overflow: 'visible',
      textOverflow: 'clip',
      width: 'fit-content'
    }),
    input: (provided) => ({
      ...provided,
      margin: '0px'
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '43px'
    })
  }

  const propSearchSj = () => {
    if (
      searchDataSj.src === '' ||
      !searchDataSj.delivery_date_start ||
      !searchDataSj.delivery_date_end
    ) {
      return { variant: 'secondary', disabled: true }
    }
    return {
      variant: 'transparent',
      className: 'btn-primary-orange',
      onClick: () => handleSearchSjDraft()
    }
  }

  const handleSearchSjDraft = () => {
    setButtonSearch(true)
    setSelectSj([])
    getSjDraftLists()
  }

  const calculateTotalQty = (type) => {
    let qtyMap = []
    if (selectSj.length > 0) {
      selectSj.forEach((sjValue) => {
        sjValue.pickup_command.forEach((command) => {
          if (
            type === 'qty' &&
            !sjValue.is_external &&
            !sjValue.is_consignment &&
            !sjValue.is_cross_dock &&
            !sjValue.is_rr
          ) {
            const { qty, uom } = command
            if (qtyMap.length === 0) {
              qtyMap.push({ qty, uom })
            } else {
              const filterQty = qtyMap.filter(
                (dataValue) => dataValue.uom === uom
              )
              if (filterQty.length > 0) {
                const newValues = qtyMap.map((value) =>
                  value.uom === uom
                    ? { ...value, qty: (value.qty += qty) }
                    : value
                )
                qtyMap = newValues
              } else {
                qtyMap.push({ qty, uom })
              }
            }
          }
          if (
            type === 'pack' &&
            !sjValue.is_external &&
            !sjValue.is_consignment &&
            !sjValue.is_cross_dock &&
            !sjValue.is_rr
          ) {
            const { total_pack, uom_pack } = command
            if (qtyMap.length === 0) {
              qtyMap.push({ qty: total_pack, uom: uom_pack })
            } else {
              const filterQty = qtyMap.filter(
                (dataValue) => dataValue.uom === uom_pack
              )
              if (filterQty.length > 0) {
                const newValues = qtyMap.map((value) =>
                  value.uom === uom_pack
                    ? { ...value, qty: (value.qty += total_pack) }
                    : value
                )
                qtyMap = newValues
              } else {
                qtyMap.push({ qty: total_pack, uom: uom_pack })
              }
            }
          }
        })
      })
      const totalQty = qtyMap
        .map((data) => `${data.qty} ${data.uom}`)
        .join(' + ')
      return totalQty === '' ? 0 : totalQty
    }
    return 0
  }

  const calculateTotalVolume = () => {
    if (selectSj.length > 0) {
      let tmpVolume = []
      selectSj.forEach((sjValue) => {
        if (
          !sjValue.is_external &&
          !sjValue.is_consignment &&
          !sjValue.is_cross_dock &&
          !sjValue.is_rr
        ) {
          sjValue.pickup_command.forEach((pickupCommand) => {
            let calculateTotalVolume = 0
            if (pickupCommand.volume_item) {
              calculateTotalVolume =
                Number(pickupCommand.qty) *
                Number(pickupCommand.volume_item || 0)
            } else {
              calculateTotalVolume =
                (Number(pickupCommand.qty) /
                  (Number(pickupCommand.qty) /
                    Number(pickupCommand.total_pack))) *
                1000000
            }
            tmpVolume.push(calculateTotalVolume)
          })
        }
      })
      if (tmpVolume.length > 0) {
        const totalVolume = tmpVolume.reduce((acc, volume) => {
          return (acc += volume ?? 0)
        }, 0)
        return totalVolume
      }
    }
    return 0
  }

  const disabledButtonContinue = useCallback(() => {
    const trExists = selectSj.some((value) => value.is_tr)
    if (trExists) {
      return false
    }
    return selectSj.every((item) => item.is_external || item.is_consignment)
  }, [selectSj])

  // Extract frontend filter choices
  const getFilterOptions = (key) => {
    const values = Array.from(
      new Set(
        dataSj
          .map((sj) => sj[key])
          .filter((v) => v !== null && v !== undefined && v !== '')
      )
    )
    return ['All', ...values]
  }

  // Filtered available tickets
  const filteredDataSj = dataSj.filter((sj) => {
    const matchAddressType =
      selectedAddressType === 'All' || sj.address_type === selectedAddressType
    const matchRayon = selectedRayon === 'All' || sj.rayon === selectedRayon
    const matchZoning = selectedZoning === 'All' || sj.zoning === selectedZoning
    return matchAddressType && matchRayon && matchZoning
  })

  // Select/Deselect all filtered rows
  const handleSelectAllFiltered = (checked) => {
    const newFiltered = filteredDataSj.map((sj) => {
      const hasShortage = isSjShortage(sj)
      if (hasShortage) {
        return { ...sj, selected: false }
      }
      return { ...sj, selected: checked }
    })

    setDataSj((prev) =>
      prev.map((item) => {
        const found = newFiltered.find((f) => f.code === item.code)
        return found ? { ...item, selected: found.selected } : item
      })
    )

    if (checked) {
      const selectables = filteredDataSj.filter((sj) => !isSjShortage(sj))
      setSelectSj((prev) => {
        const missing = selectables.filter(
          (f) => !prev.some((p) => p.code === f.code)
        )
        return [...prev, ...missing]
      })
    } else {
      setSelectSj((prev) =>
        prev.filter((p) => !filteredDataSj.some((f) => f.code === p.code))
      )
    }
  }

  const selectableFiltered = filteredDataSj.filter((sj) => !isSjShortage(sj))

  const isAllFilteredSelected =
    selectableFiltered.length > 0 &&
    selectableFiltered.every((sj) => sj.selected)

  return (
    <div style={{ minHeight: '100vh', paddingBottom: '120px' }}>
      <style>{`
        .hover-orange {
          transition: color 0.2s ease;
        }
        .hover-orange:hover {
          color: var(--primary-orange) !important;
        }
        .date-picker-45 {
          width: 100% !important;
        }
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        .animate-spin {
          animation: spin 1s linear infinite;
        }
        .bottom-floating-bar {
          position: fixed;
          left: 50%;
          transform: translateX(-50%);
          width: calc(100% - 48px);
          max-width: 1200px;
          background-color: rgba(255, 255, 255, 0.96);
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
          border-radius: 20px;
          padding: 1.25rem 2.5rem;
          z-index: 1050;
          border: 1px solid rgba(0, 0, 0, 0.06);
          backdrop-filter: blur(10px);
          transition: bottom 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }
        @media (min-width: 768px) {
          .bottom-floating-bar {
            left: calc(50% + 8.33%);
            width: calc(100% - 280px);
            max-width: 1000px;
          }
        }
      `}</style>
      <Container>
        <Row>
          <Col>
            <h4 style={headerTitleStyle}>Create Outbound Plan</h4>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb" style={{ fontSize: '12px' }}>
                <li className="breadcrumb-item sj-item">
                  <Link to="/outbound/plan" className="text-decoration-none">
                    <span className="text-black fw-bold">OUTBOUND PLAN</span>
                  </Link>
                </li>
                <li
                  className="breadcrumb-item sj-item active text-uppercase"
                  aria-current="page"
                >
                  Create
                </li>
              </ol>
            </nav>
          </Col>
        </Row>
        <Row>
          <Col>
            <p className="text-muted">
              Please fill all fields to query SJ draft
            </p>
          </Col>
        </Row>

        <Card style={cardStyle}>
          <Row className="align-items-end">
            <Col xs={12} md={3} lg={3}>
              <Form.Group
                className="mb-3 text-muted"
                controlId="sourcewarehouse"
              >
                <Form.Label style={labelDetailStyle}>
                  SOURCE WAREHOUSE <sup className="text-danger">*</sup>
                </Form.Label>
                <Select
                  name="src"
                  options={warehouses}
                  onChange={(e) => {
                    handleSearchDataSj('src', e?.value ?? '')
                  }}
                  isClearable
                  isSearchable
                  styles={customStyles}
                  value={
                    warehouses?.find(
                      (warehouse) => warehouse.value === searchDataSj.src
                    ) || ''
                  }
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={3} lg={3}>
              <Form.Group
                className="mb-3 text-muted"
                controlId="sourcewarehouse"
              >
                <Form.Label style={labelDetailStyle} className="text-uppercase">
                  External and consignment warehouse
                </Form.Label>
                <Select
                  name="other_src"
                  options={warehouseExternals}
                  onChange={(selectedOption) => {
                    handleSearchDataSj('other_src', selectedOption)
                  }}
                  isClearable
                  isSearchable
                  isMulti
                  styles={customMultiStyles}
                  value={searchDataSj.other_src || []}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={4} lg={4}>
              <Form.Group className="mb-3 text-muted" controlId="deliverydate">
                <Form.Label style={labelDetailStyle}>
                  DELIVERY DATE RANGE <sup className="text-danger">*</sup>
                </Form.Label>
                <div className="d-flex flex-row align-items-center gap-2">
                  <div style={{ flex: 1 }}>
                    <InputDatePicker
                      value={searchDataSj.delivery_date_start}
                      onChange={(date) =>
                        setSearchDataSj((prev) => ({
                          ...prev,
                          delivery_date_start: moment(date).format('YYYY-MM-DD')
                        }))
                      }
                      className="date-picker-45"
                    />
                  </div>
                  <span className="text-muted fw-bold">to</span>
                  <div style={{ flex: 1 }}>
                    <InputDatePicker
                      value={searchDataSj.delivery_date_end}
                      onChange={(date) =>
                        setSearchDataSj((prev) => ({
                          ...prev,
                          delivery_date_end: moment(date).format('YYYY-MM-DD')
                        }))
                      }
                      className="date-picker-45"
                    />
                  </div>
                </div>
              </Form.Group>
            </Col>
            <Col xs={12} md={2} lg={2} className="mb-3">
              <Button
                {...propSearchSj()}
                className="w-100 btn-primary-orange font-weight-bold"
                style={{
                  height: '45px',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                Search
              </Button>
            </Col>
          </Row>
        </Card>
      </Container>

      {state && !buttonSearch && (
        <div className="d-flex flex-row justify-content-center p-5">
          <div className="d-flex flex-row gap-2 align-items-center">
            <Loader2 size={24} className="animate-spin text-orange" />
            <span className="fs-6 fw-semibold text-muted">
              Loading Drafts...
            </span>
          </div>
        </div>
      )}

      {buttonSearch && (
        <>
          <Container className="mt-4">
            <Card style={{ ...cardStyle, marginBottom: '1.25rem' }}>
              <h6
                className="fw-bold mb-3 text-muted text-uppercase"
                style={{ fontSize: '12px', letterSpacing: '0.5px' }}
              >
                Filter Draft List
              </h6>
              <Row className="g-3">
                <Col xs={12} md={4}>
                  <Form.Group controlId="filterAddressType">
                    <Form.Label style={labelDetailStyle}>
                      Address Type
                    </Form.Label>
                    <Form.Select
                      style={{
                        height: '38px',
                        borderRadius: '8px',
                        fontSize: '14px'
                      }}
                      value={selectedAddressType}
                      onChange={(e) => setSelectedAddressType(e.target.value)}
                    >
                      {getFilterOptions('address_type').map((opt) => (
                        <option key={opt} value={opt}>
                          {opt || 'Empty'}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group controlId="filterRayon">
                    <Form.Label style={labelDetailStyle}>Rayon</Form.Label>
                    <Form.Select
                      style={{
                        height: '38px',
                        borderRadius: '8px',
                        fontSize: '14px'
                      }}
                      value={selectedRayon}
                      onChange={(e) => setSelectedRayon(e.target.value)}
                    >
                      {getFilterOptions('rayon').map((opt) => (
                        <option key={opt} value={opt}>
                          {opt || 'Empty'}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group controlId="filterZoning">
                    <Form.Label style={labelDetailStyle}>Zoning</Form.Label>
                    <Form.Select
                      style={{
                        height: '38px',
                        borderRadius: '8px',
                        fontSize: '14px'
                      }}
                      value={selectedZoning}
                      onChange={(e) => setSelectedZoning(e.target.value)}
                    >
                      {getFilterOptions('zoning').map((opt) => (
                        <option key={opt} value={opt}>
                          {opt || 'Empty'}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Card>

            <Card style={cardStyle} className="overflow-hidden">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4 pb-3 border-bottom">
                <h5 className="fw-bold mb-0 text-muted text-uppercase">
                  Available Draft List
                </h5>
              </div>

              {loadingListSj ? (
                <div className="text-center py-5">
                  <Loader2 size={36} className="animate-spin text-orange" />
                  <p className="mt-2 text-muted fw-semibold">Loading data...</p>
                </div>
              ) : filteredDataSj.length === 0 ? (
                <div className="text-center py-5">
                  <AlertCircle size={40} className="text-muted mb-2" />
                  <p className="fw-bold text-muted mb-0">
                    No drafts matching selection
                  </p>
                </div>
              ) : (
                <div className="table-responsive">
                  <Table
                    hover
                    style={{
                      verticalAlign: 'middle',
                      borderCollapse: 'separate',
                      borderSpacing: '0 8px'
                    }}
                  >
                    <thead>
                      <tr>
                        <th style={tableHeaderStyle} width="40px">
                          <Form.Check
                            type="checkbox"
                            checked={isAllFilteredSelected}
                            onChange={(e) =>
                              handleSelectAllFiltered(e.target.checked)
                            }
                          />
                        </th>
                        <th style={tableHeaderStyle}>#SJ - SO</th>
                        <th style={tableHeaderStyle}>Customer</th>
                        <th style={tableHeaderStyle}>Address</th>
                        <th style={tableHeaderStyle}>Type</th>
                        <th style={tableHeaderStyle}>Rayon</th>
                        <th style={tableHeaderStyle}>Zoning</th>
                        <th style={tableHeaderStyle}>Delivery Date</th>
                        <th
                          style={tableHeaderStyle}
                          width="80px"
                          className="text-center"
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredDataSj.map((sj) => {
                        const isExpanded = expandedRows[sj.code] !== false
                        const hasShortage = isSjShortage(sj)
                        return (
                          <Fragment key={sj.code}>
                            <tr
                              key={sj.code}
                              style={{
                                backgroundColor: hasShortage
                                  ? 'rgba(220, 53, 69, 0.05)'
                                  : sj.selected
                                    ? 'rgba(247, 147, 30, 0.04)'
                                    : '#fff',
                                transition: 'background-color 0.2s ease',
                                cursor: hasShortage ? 'not-allowed' : 'default'
                              }}
                            >
                              <td className="border-top-0 border-bottom">
                                <Form.Check
                                  type="checkbox"
                                  checked={sj.selected}
                                  disabled={hasShortage}
                                  onChange={(e) =>
                                    handleSelectSj(sj.code, e.target.checked)
                                  }
                                />
                              </td>
                              <td className="border-top-0 border-bottom fw-bold text-dark">
                                {sj.code}{' '}
                                <div className="small text-muted fw-normal">
                                  {sj.sales_order}
                                </div>
                              </td>
                              <td className="border-top-0 border-bottom fw-semibold text-muted">
                                {sj.customer}
                              </td>
                              <td className="border-top-0 border-bottom">
                                <div
                                  style={{
                                    fontSize: '12px',
                                    color: '#666',
                                    maxWidth: '200px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: sj.delivery_address
                                  }}
                                  title={sj.delivery_address}
                                ></div>
                              </td>
                              <td className="border-top-0 border-bottom">
                                <span
                                  className={`badge rounded-pill ${sj.address_type === 'Shipping' ? 'bg-info text-white' : 'bg-secondary'}`}
                                >
                                  {sj.address_type || '-'}
                                </span>
                              </td>
                              <td className="border-top-0 border-bottom">
                                {sj.rayon || '-'}
                              </td>
                              <td className="border-top-0 border-bottom">
                                {sj.zoning || '-'}
                              </td>
                              <td className="border-top-0 border-bottom fw-semibold">
                                {sj.delivery_date
                                  ? moment(sj.delivery_date).format(
                                      'DD-MM-YYYY'
                                    )
                                  : '-'}
                              </td>
                              <td className="border-top-0 border-bottom text-center">
                                <Button
                                  variant="link"
                                  size="sm"
                                  className="text-orange p-0"
                                  onClick={() => toggleRow(sj.code)}
                                >
                                  {isExpanded ? (
                                    <ChevronDown
                                      size={20}
                                      style={{
                                        transform: 'rotate(180deg)',
                                        transition: 'transform 0.2s'
                                      }}
                                    />
                                  ) : (
                                    <ChevronRight
                                      size={20}
                                      style={{ transition: 'transform 0.2s' }}
                                    />
                                  )}
                                </Button>
                              </td>
                            </tr>

                            {isExpanded && (
                              <tr style={{ backgroundColor: '#fafafa' }}>
                                <td
                                  colSpan={9}
                                  className="p-3 border-bottom shadow-inner"
                                >
                                  <div className="px-4 py-2 bg-white rounded shadow-sm">
                                    <Table
                                      size="sm"
                                      borderless
                                      responsive
                                      className="mb-0"
                                    >
                                      <thead>
                                        <tr
                                          className="border-bottom text-muted"
                                          style={{ fontSize: '11px' }}
                                        >
                                          <th>Item Code - Name</th>
                                          <th>Item Alias</th>
                                          <th>Batch</th>
                                          <th>Expired</th>
                                          <th className="text-end">
                                            Pengambilan
                                          </th>
                                          <th className="text-end">
                                            Available Qty
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {(sj.items || []).map((item, idx) => {
                                          const isShortage =
                                            isItemShortage(item)

                                          return (
                                            <tr
                                              key={idx}
                                              style={{ fontSize: '12px' }}
                                              className="border-bottom-subtle"
                                            >
                                              <td className="py-2 fw-semibold">
                                                {item.item_code} -{' '}
                                                {item.item_name}
                                              </td>
                                              <td className="py-2 text-muted">
                                                {item.item_alias || '-'}
                                              </td>
                                              <td className="py-2 fw-mono">
                                                {item.batch || '-'}
                                              </td>
                                              <td className="py-2">
                                                {item.batch_exp
                                                  ? moment(
                                                      item.batch_exp
                                                    ).format('DD-MM-YYYY')
                                                  : '-'}
                                              </td>
                                              <td className="py-2 text-end fw-bold text-orange">
                                                {item.pick_up_pack}{' '}
                                                {item.pick_up_pack_uom ||
                                                  item.pick_up_uom}
                                              </td>
                                              <td
                                                className={`py-2 text-end fw-bold ${isShortage ? 'text-danger' : 'text-success'}`}
                                              >
                                                {item.available_qty}{' '}
                                                {item.available_qty_uom}
                                                {isShortage && (
                                                  <div
                                                    className="small text-danger fw-normal"
                                                    style={{ fontSize: '10px' }}
                                                  >
                                                    (Shortage)
                                                  </div>
                                                )}
                                              </td>
                                            </tr>
                                          )
                                        })}
                                      </tbody>
                                    </Table>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </Fragment>
                        )
                      })}
                    </tbody>
                  </Table>
                </div>
              )}
            </Card>
          </Container>

          {/* Elegant Slide-In Bottom Floating summary bar */}
          <div
            className="bottom-floating-bar"
            style={{
              bottom: selectSj.length > 0 ? '24px' : '-120px'
            }}
          >
            <Row className="align-items-center">
              <Col
                xs={12}
                md={3}
                className="text-center text-md-start mb-2 mb-md-0"
              >
                <div className="d-flex flex-row align-items-center justify-content-center justify-content-md-start gap-2">
                  <Maximize2
                    size={18}
                    className="text-muted cursor-pointer hover-orange me-1"
                    style={{ cursor: 'pointer' }}
                    onClick={() => fetchSuggestDetails()}
                  />
                  <div
                    style={{
                      backgroundColor: 'var(--primary-orange)',
                      color: '#fff',
                      borderRadius: '50%',
                      width: '32px',
                      height: '32px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 'bold',
                      fontSize: '14px'
                    }}
                  >
                    {selectSj.length}
                  </div>
                  <span
                    className="fw-bold text-dark"
                    style={{ letterSpacing: '0.3px' }}
                  >
                    TICKET{selectSj.length > 1 ? 'S' : ''} SELECTED
                  </span>
                </div>
              </Col>
              <Col xs={12} md={6} className="mb-2 mb-md-0">
                <div className="d-flex flex-row justify-content-center align-items-center gap-4 text-center">
                  <div>
                    <span
                      className="small text-uppercase text-muted fw-bold d-block"
                      style={{ fontSize: '10px' }}
                    >
                      Total Qty
                    </span>
                    <span
                      className="fw-bold text-orange"
                      style={{ fontSize: '14px' }}
                    >
                      {calculateTotalQty('qty')}
                    </span>
                  </div>
                  <div
                    style={{
                      height: '24px',
                      width: '1px',
                      backgroundColor: '#e0e0e0'
                    }}
                  ></div>
                  <div>
                    <span
                      className="small text-uppercase text-muted fw-bold d-block"
                      style={{ fontSize: '10px' }}
                    >
                      Total Pack
                    </span>
                    <span
                      className="fw-bold text-orange"
                      style={{ fontSize: '14px' }}
                    >
                      {calculateTotalQty('pack')}
                    </span>
                  </div>
                  <div
                    style={{
                      height: '24px',
                      width: '1px',
                      backgroundColor: '#e0e0e0'
                    }}
                  ></div>
                  <div>
                    <span
                      className="small text-uppercase text-muted fw-bold d-block"
                      style={{ fontSize: '10px' }}
                    >
                      Total Volume
                    </span>
                    <span
                      className="fw-bold text-orange"
                      style={{ fontSize: '14px' }}
                    >
                      {formatThousandSeparator(calculateTotalVolume())} cm3
                    </span>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={3} className="text-center text-md-end">
                <Button
                  onClick={() => fetchSuggestDetails()}
                  variant="transparent"
                  className={`w-100 py-2 fw-bold text-uppercase ${
                    disabledButtonContinue()
                      ? 'btn-secondary opacity-25'
                      : 'btn-primary-orange'
                  }`}
                  disabled={disabledButtonContinue()}
                  style={{ borderRadius: '10px' }}
                >
                  Continue
                </Button>
              </Col>
            </Row>
          </div>
        </>
      )}

      {/* Suggested Tickets Stock Review Modal */}
      <Modal
        show={showModalSuggest}
        onHide={() => setShowModalSuggest(false)}
        centered
        size="xl"
        contentClassName="border-0 shadow-lg"
        style={{ borderRadius: '16px', overflow: 'hidden' }}
      >
        <Modal.Header className="bg-light border-0 py-3 px-4 d-flex justify-content-between align-items-center">
          <div className="d-flex flex-row flex-wrap align-items-center gap-3 w-100">
            <span
              className="fw-bold text-dark fs-5 text-uppercase"
              style={{ letterSpacing: '0.3px' }}
            >
              {selectSj.length} TICKET{selectSj.length > 1 ? 'S' : ''} SELECTED
            </span>
            <div className="d-flex flex-row align-items-center gap-4 text-muted small ms-md-4">
              <div>
                <span
                  className="fw-bold text-uppercase text-muted"
                  style={{ fontSize: '10px', letterSpacing: '0.3px' }}
                >
                  Qty :
                </span>{' '}
                <span
                  className="fw-bold text-orange"
                  style={{ fontSize: '14px' }}
                >
                  {calculateTotalQty('qty')}
                </span>
              </div>
              <div
                style={{
                  height: '16px',
                  width: '1px',
                  backgroundColor: '#e0e0e0'
                }}
              ></div>
              <div>
                <span
                  className="fw-bold text-uppercase text-muted"
                  style={{ fontSize: '10px', letterSpacing: '0.3px' }}
                >
                  Pack :
                </span>{' '}
                <span
                  className="fw-bold text-orange"
                  style={{ fontSize: '14px' }}
                >
                  {calculateTotalQty('pack')}
                </span>
              </div>
              <div
                style={{
                  height: '16px',
                  width: '1px',
                  backgroundColor: '#e0e0e0'
                }}
              ></div>
              <div>
                <span
                  className="fw-bold text-uppercase text-muted"
                  style={{ fontSize: '10px', letterSpacing: '0.3px' }}
                >
                  Vol :
                </span>{' '}
                <span
                  className="fw-bold text-orange"
                  style={{ fontSize: '14px' }}
                >
                  {formatThousandSeparator(calculateTotalVolume())} cm3
                </span>
              </div>
            </div>
          </div>
          <Button
            variant="link"
            className="text-muted p-0 ms-auto"
            onClick={() => setShowModalSuggest(false)}
          >
            <X size={20} />
          </Button>
        </Modal.Header>
        <Modal.Body
          className="py-4 px-4"
          style={{ backgroundColor: '#fcfcfc', minHeight: '300px' }}
        >
          {loadingSuggest ? (
            <div className="d-flex flex-column align-items-center justify-content-center py-5 my-5">
              <Loader2 size={48} className="animate-spin text-orange" />
              <p className="mt-3 text-muted fw-bold">
                Calculating Stock Availability...
              </p>
            </div>
          ) : suggestedSjs.length === 0 ? (
            <div className="text-center py-5 my-5">
              <AlertCircle size={48} className="text-muted mb-3" />
              <h5 className="fw-bold text-muted">
                No drafts selected or suggested
              </h5>
            </div>
          ) : (
            <div
              className="table-responsive"
              style={{ maxHeight: '550px', overflowY: 'auto' }}
            >
              <Table
                hover
                style={{
                  verticalAlign: 'middle',
                  borderCollapse: 'separate',
                  borderSpacing: '0 8px'
                }}
              >
                <thead>
                  <tr>
                    <th style={tableHeaderStyle} width="50px"></th>
                    <th style={tableHeaderStyle}>#SJ - SO</th>
                    <th style={tableHeaderStyle}>Customer</th>
                    <th style={tableHeaderStyle}>Address</th>
                    <th style={tableHeaderStyle}>Address Type</th>
                    <th style={tableHeaderStyle}>Rayon</th>
                    <th style={tableHeaderStyle}>Zoning</th>
                    <th style={tableHeaderStyle}>Delivery Date</th>
                    <th
                      style={tableHeaderStyle}
                      width="80px"
                      className="text-center"
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {suggestedSjs.map((sj) => {
                    const isExpanded = expandedSuggestRows[sj.code] !== false
                    return (
                      <Fragment key={sj.code}>
                        <tr
                          key={sj.code}
                          style={{
                            backgroundColor: '#fff',
                            transition: 'background-color 0.2s ease'
                          }}
                        >
                          <td className="border-top-0 border-bottom text-center">
                            <Button
                              variant="danger"
                              size="sm"
                              className="p-1 d-inline-flex align-items-center justify-content-center"
                              style={{
                                width: '32px',
                                height: '32px',
                                borderRadius: '6px'
                              }}
                              onClick={() => handleDeleteSuggestSj(sj.code)}
                            >
                              <Trash2 size={16} />
                            </Button>
                          </td>
                          <td className="border-top-0 border-bottom fw-bold text-dark">
                            {sj.code}{' '}
                            <div className="small text-muted fw-normal">
                              {sj.sales_order}
                            </div>
                          </td>
                          <td className="border-top-0 border-bottom fw-semibold text-muted">
                            {sj.customer}
                          </td>
                          <td className="border-top-0 border-bottom">
                            <div
                              style={{
                                fontSize: '12px',
                                color: '#666',
                                maxWidth: '200px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}
                              dangerouslySetInnerHTML={{
                                __html: sj.delivery_address
                              }}
                              title={sj.delivery_address}
                            ></div>
                          </td>
                          <td className="border-top-0 border-bottom">
                            <span
                              className={`badge rounded-pill ${sj.address_type === 'Shipping' ? 'bg-info text-white' : 'bg-secondary'}`}
                            >
                              {sj.address_type || '-'}
                            </span>
                          </td>
                          <td className="border-top-0 border-bottom">
                            {sj.rayon || '-'}
                          </td>
                          <td className="border-top-0 border-bottom">
                            {sj.zoning || '-'}
                          </td>
                          <td className="border-top-0 border-bottom fw-semibold">
                            {sj.delivery_date
                              ? moment(sj.delivery_date).format('DD-MM-YYYY')
                              : '-'}
                          </td>
                          <td className="border-top-0 border-bottom text-center">
                            <Button
                              variant="link"
                              size="sm"
                              className="text-orange p-0"
                              onClick={() => toggleSuggestRow(sj.code)}
                            >
                              {isExpanded ? (
                                <ChevronDown
                                  size={20}
                                  style={{
                                    transform: 'rotate(180deg)',
                                    transition: 'transform 0.2s'
                                  }}
                                />
                              ) : (
                                <ChevronRight
                                  size={20}
                                  style={{ transition: 'transform 0.2s' }}
                                />
                              )}
                            </Button>
                          </td>
                        </tr>

                        {isExpanded && (
                          <tr style={{ backgroundColor: '#fafafa' }}>
                            <td
                              colSpan={9}
                              className="p-3 border-bottom shadow-inner"
                            >
                              <div className="px-4 py-2 bg-white rounded shadow-sm">
                                <Table
                                  size="sm"
                                  borderless
                                  responsive
                                  className="mb-0"
                                >
                                  <thead>
                                    <tr
                                      className="border-bottom text-muted"
                                      style={{ fontSize: '11px' }}
                                    >
                                      <th>Item Code - Name</th>
                                      <th>Item Alias</th>
                                      <th>Batch</th>
                                      <th>Expired</th>
                                      <th className="text-end">Pengambilan</th>
                                      <th className="text-end">
                                        Available Qty
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {(sj.items || []).map((item, idx) => {
                                      const isShortage = isItemShortage(item)

                                      return (
                                        <tr
                                          key={idx}
                                          style={{ fontSize: '12px' }}
                                          className="border-bottom-subtle"
                                        >
                                          <td className="py-2 fw-semibold">
                                            {item.item_code} - {item.item_name}
                                          </td>
                                          <td className="py-2 text-muted">
                                            {item.item_alias || '-'}
                                          </td>
                                          <td className="py-2 fw-mono">
                                            <span
                                              className="text-primary fw-bold text-decoration-none"
                                              style={{
                                                cursor: 'pointer',
                                                borderBottom:
                                                  '1px dashed var(--bs-primary)'
                                              }}
                                              onClick={() =>
                                                handleOpenBatchSelector(
                                                  sj.code,
                                                  item
                                                )
                                              }
                                              title="Click to change batch"
                                            >
                                              {item.batch || '-'}
                                            </span>
                                          </td>
                                          <td className="py-2">
                                            {item.batch_exp
                                              ? moment(item.batch_exp).format(
                                                  'DD-MM-YYYY'
                                                )
                                              : '-'}
                                          </td>
                                          <td className="py-2 text-end fw-bold text-orange">
                                            {item.pick_up_pack}{' '}
                                            {item.pick_up_pack_uom ||
                                              item.pick_up_uom}
                                          </td>
                                          <td
                                            className={`py-2 text-end fw-bold ${isShortage ? 'text-danger' : 'text-success'}`}
                                          >
                                            {item.available_qty}{' '}
                                            {item.available_qty_uom}
                                            {isShortage && (
                                              <div
                                                className="small text-danger fw-normal"
                                                style={{ fontSize: '10px' }}
                                              >
                                                (Shortage)
                                              </div>
                                            )}
                                          </td>
                                        </tr>
                                      )
                                    })}
                                  </tbody>
                                </Table>
                              </div>
                            </td>
                          </tr>
                        )}
                      </Fragment>
                    )
                  })}
                </tbody>
              </Table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="bg-light border-0 py-3 px-4">
          <Button
            onClick={() => {
              setShowModalSuggest(false)
              const selectedWh = warehouses?.find(
                (item) => item.value === searchDataSj.src
              )
              navigate('/outbound/plan/create/detail', {
                state: {
                  selectedSj: suggestedSjs,
                  filterData: {
                    ...searchDataSj,
                    srcUuid: selectedWh?.id || '',
                    srcLabel: selectedWh?.label || searchDataSj.src
                  }
                }
              })
            }}
            variant="transparent"
            className={`w-100 py-3 fw-bold text-uppercase shadow-sm ${
              suggestedSjs.length === 0 ||
              loadingSuggest ||
              suggestedSjs.some(isSjShortage)
                ? 'btn-secondary opacity-50'
                : 'btn-primary-orange'
            }`}
            style={{
              borderRadius: '12px',
              fontSize: '15px',
              letterSpacing: '0.5px'
            }}
            disabled={
              suggestedSjs.length === 0 ||
              loadingSuggest ||
              suggestedSjs.some(isSjShortage)
            }
          >
            Continue
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Elegant Batch Selection Modal */}
      <Modal
        show={showModalBatch}
        onHide={() => setShowModalBatch(false)}
        centered
        size="md"
        contentClassName="border-0 shadow-lg"
        style={{ borderRadius: '16px', overflow: 'hidden' }}
      >
        <Modal.Header closeButton className="bg-light border-0 py-3 px-4">
          <Modal.Title
            className="fw-bold text-dark fs-5 text-uppercase"
            style={{ letterSpacing: '0.3px' }}
          >
            Select Batch
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-3 px-4">
          {loadingBatches ? (
            <div className="d-flex flex-column align-items-center justify-content-center py-5">
              <Loader2 size={36} className="animate-spin text-orange" />
              <p className="mt-3 text-muted fw-semibold">
                Loading available batches...
              </p>
            </div>
          ) : availableBatches.length === 0 ? (
            <div className="text-center py-4 text-muted">
              <AlertCircle size={36} className="mb-2 text-warning" />
              <p className="fw-semibold">
                No active batches available in this warehouse
              </p>
            </div>
          ) : (
            <div className="table-responsive">
              <Table
                hover
                size="sm"
                style={{ verticalAlign: 'middle', fontSize: '13px' }}
              >
                <thead className="table-light">
                  <tr>
                    <th>Batch</th>
                    <th className="text-center">Available Pack</th>
                    <th>Expired Date</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {availableBatches.map((batchItem, index) => {
                    const isCurrent =
                      activeSelectBatchInfo?.item?.batch === batchItem.batch
                    const isInsufficient =
                      Number(batchItem.total_pack) <
                      Number(activeSelectBatchInfo?.item?.pick_up_pack || 0)
                    return (
                      <tr
                        key={index}
                        style={{
                          backgroundColor: isCurrent
                            ? '#fff9db'
                            : isInsufficient
                              ? '#fff5f5'
                              : '',
                          opacity: isInsufficient && !isCurrent ? 0.65 : 1,
                          transition: 'opacity 0.2s ease'
                        }}
                      >
                        <td className="fw-bold fw-mono">{batchItem.batch}</td>
                        <td className="text-center fw-semibold text-orange">
                          {batchItem.total_pack} Pack
                        </td>
                        <td className="text-muted">
                          {batchItem.expired_date || '-'}
                        </td>
                        <td className="text-center">
                          <Button
                            variant={
                              isCurrent || isInsufficient
                                ? 'secondary'
                                : 'transparent'
                            }
                            className={
                              isCurrent || isInsufficient
                                ? 'opacity-50'
                                : 'btn-primary-orange'
                            }
                            size="sm"
                            disabled={isCurrent || isInsufficient}
                            onClick={() => handleSelectNewBatch(batchItem)}
                            style={{
                              borderRadius: '6px',
                              fontSize: '11px',
                              padding: '0.25rem 0.75rem'
                            }}
                          >
                            {isCurrent
                              ? 'Selected'
                              : isInsufficient
                                ? 'Insufficient'
                                : 'Select'}
                          </Button>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>
          )}
        </Modal.Body>
      </Modal>

      <Toaster />
    </div>
  )
}

export default CreateOutboundPlan
